import { lazy } from "react";

const Results = lazy(() => import("@views/Survey/Results"))
const SurveyMain = lazy(() => import("@views/Survey/SurveyMain"))
const ResultDetail= lazy(() => import("@views/Survey/Results/ResultDetail") )

const SurveyRoutes = [
    {
        path: 'survey/addsurvey',
        element: <SurveyMain />
    },
    {
        path: 'survey/results',
        element: <Results/>
    },
    {
        path:'survey/results/resultdetail/:id/',
        element: <ResultDetail />
    }

]
export default SurveyRoutes
